export enum PopoverPosition {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
}

export interface PopoverOptions {
  title?: string;
  body: string;
  canClose: boolean;
  position: PopoverPosition;
  asTooltip: boolean;
  visible: boolean;
}

export interface InputTooltipOptions {
  text: string;
}
